<template>
  <div class="col-12 col-md-6 pa-0" :class="[question?.StyleClass]">
    <HomeBaseLabel :question="question" :class="[question?.LabelStyleClass]">
      <template #actionLabel
        ><!-- Use Address Finder -->
        <a
          href="#"
          @click.prevent="tryAgain(question)"
          class="ma-0 float-right black--text text-right address-finder"
          v-if="isPostcodeQuestion"
          >{{ isD2CQuestion ? "Use address finder" : "Use Address Finder" }}</a
        >
      </template>
    </HomeBaseLabel>
    <v-textarea
      :id="question?.Vid"
      v-if="question.IsTextArea"
      :class="[question?.TextFieldStyleClass]"
      v-model="question.Value"
      :data-uiid="question.DataUiid"
      no-resize
      :rules="getRules"
      outlined
      dense
      validate-on-blur
      @focus="onFocus"
      @blur="onBlur"
      ref="inputBase"
      trimmed
      :placeholder="question.AnswerControlAttributePlaceholder"
      :hide-details="
        question.HideDetails != null ? question.HideDetails : 'auto'
      "
      :aria-label="question?.Text ?? ''"
    ></v-textarea>
    <v-text-field
      :id="question?.Vid"
      v-else
      v-mask="question?.MoneyFormat ? currencyMask : false"
      :class="[question?.TextFieldStyleClass]"
      dense
      validate-on-blur
      outlined
      :hide-details="
        question.HideDetails != null ? question.HideDetails : 'auto'
      "
      :data-uiid="
        question?.MoneyFormat
          ? `${question.DataUiid}_MoneyFormat`
          : question.DataUiid
      "
      :type="question.AnswerControlAttributeType"
      v-model="question.Value"
      :placeholder="question.AnswerControlAttributePlaceholder"
      :rules="getRules"
      @blur="onBlur"
      @focus="onFocus"
      :aria-label="question?.Text ?? ''"
      ref="inputBase"
    >
      <template v-slot:append>
        <span v-if="$refs.inputBase?.valid && question.Value?.length">
          <v-icon color="green" size="20" :class="[question?.IconStyleClass]"
            >mdi-check-circle</v-icon
          >
        </span>
        <span v-if="!$refs.inputBase?.valid && $refs.inputBase?.hasMessages">
          <v-icon color="red" size="20" :class="[question?.IconStyleClass]"
            >mdi-alert-circle</v-icon
          >
        </span>
      </template>
      <template v-slot:prepend-inner>
        <strong
          class="font-16"
          v-if="question.InterfaceKey === 'PreviousClaimAmountOfLoss'"
          >£</strong
        >
      </template>
    </v-text-field>
  </div>
</template>

<script>
import AllQuestionsMixin from "@/Mixins/AllQuestionsMixin";
import QuestionValidation from "@/Mixins/Validation/QuestionValidation";
import { resetAddressLayoutAnswers } from "@/common/addresses";
import { currencyMask } from "@/common/utils";
import HomeBaseLabel from "@/components/HomeComponents/HomeBaseComponents/HomeBaseLabel";

export default {
  name: "InputBase",
  components: {
    HomeBaseLabel,
  },
  mixins: [QuestionValidation, AllQuestionsMixin],
  props: {
    question: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isPostcodeQuestion() {
      return this.question.InterfaceKey.endsWith("PostCode");
    },
    isD2CQuestion() {
      return this.question.IsD2C;
    },
  },
  data() {
    return {
      currencyMask,
    };
  },
  methods: {
    tryAgain(question) {
      const layoutType =
        question.InterfaceKey === "InsuredAddressPostCode"
          ? "LayoutAddressSearchLexisNexis"
          : "LayoutAddressSearchBase";

      resetAddressLayoutAnswers(
        this.allQuestions,
        layoutType,
        this.question.InterfaceKey
      );
      this.$emit("tryAgain");
    },
    onBlur(e) {
      this.question.Value = this.question.Value?.trim();
      this.$emit("blur", e);
    },
    onFocus(e) {
      this.$emit("focus", e);
    },
  },
};
</script>

<style lang="scss" scoped>
.icon-mt {
  margin-top: -3px !important;
}
.address-finder {
  color: #272727 !important;
}
.label-mt {
  margin-top: 9px !important;
}
.label-mb {
  margin-bottom: 9px !important;
}
.phone-address-text-field-mb {
  margin-bottom: 34px !important;
}
.year-built {
  width: 200px !important;
  .v-input__control .v-input__slot .v-text-field__slot .v-text-field__slot {
    padding-top: 4px;
    padding-bottom: 4px;
  }
}
.additional-info {
  margin-bottom: -15px !important;
  .v-input__control .v-input__slot {
    height: 120px !important;
  }
  :deep(.v-input__control .v-input__slot .v-text-field__slot) {
    padding-bottom: 10px;
    padding-right: 5px !important;
  }
}
.mortgage-lender {
  margin-top: -3px !important;
}
.your-app-text-field {
  width: 440px !important;
}
:deep(.v-text-field.v-text-field--enclosed .v-text-field__details) {
  padding-left: 0;
}
</style>
